export default __webpack_public_path__ + "static/media/tusd.39cce0d7.svg";